import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import IconButton from '../IconButton/IconButton.component.js';
import { propTypes, defaultProps } from './ImageWithActions.types.js';
import styles from './ImageWithActions.module.scss.js';

var ImageWithActions = /** @class */ (function (_super) {
    __extends(ImageWithActions, _super);
    function ImageWithActions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            hover: false,
        };
        _this.onMouseEnter = function () {
            _this.setState({ hover: true });
        };
        _this.onMouseLeave = function () {
            _this.setState({ hover: false });
        };
        return _this;
    }
    ImageWithActions.prototype.render = function () {
        var _a = this.props, label = _a.label, imgUrl = _a.imgUrl, imgAlt = _a.imgAlt, className = _a.className, width = _a.width, height = _a.height, actions = _a.actions;
        var hover = this.state.hover;
        /** { [key: string]: any } workaround for TS not liking dynamic obj properties */
        var style = {};
        if (width)
            style.width = width + "px";
        if (height)
            style.height = height + "px";
        return (React__default.createElement("div", { style: style, className: clsx(styles.ImageContainer, className), onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
            React__default.createElement("img", { className: styles.ImageContainer_image, src: imgUrl, alt: imgAlt }),
            label && (React__default.createElement("div", { className: styles.LabelContainer },
                React__default.createElement("h5", { className: styles.LabelContainer_text }, label))),
            React__default.createElement("div", { className: styles.ActionsWrapper, style: { display: hover ? 'flex' : 'none' } }, actions.map(function (action, idx) { return (React__default.createElement("div", { className: clsx(styles.Action, styles["DelayedAnimation" + (idx + 1)]), key: action.iconName },
                React__default.createElement(IconButton, { className: clsx(styles.Action_button, action.className || ''), color: action.color, name: action.iconName, alt: action.iconAlt, size: 24, onClick: action.onClick, buttonProps: {
                        type: 'button',
                    } }),
                React__default.createElement("p", { className: styles.Action_text }, action.title))); }))));
    };
    ImageWithActions.displayName = 'ImageWithActions';
    ImageWithActions.propTypes = propTypes;
    ImageWithActions.defaultProps = __assign({}, defaultProps);
    return ImageWithActions;
}(React__default.Component));

export { ImageWithActions as default };
